import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import "./Categories.css"; // Custom CSS for further styling

const CategoriesHome = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${API}/api/channel/view_all_active_channel`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                console.log(res.data)
                setCategories(res.data?.channels);
            } catch (error) {
                console.error("Error fetching Channel:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);
    const generateSlug = (name) => {
          return name.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

    };
    return (
        <div className="category-home">
            {
                loading ? (
                    <div className="loading-indicator" >
                        <div className="dot"></div>
                        <div className="dot"></div>
                        <div className="dot"></div>
                    </div>) : categories?.length !== 0 && (
                        <>
                            <h5 className="category-title">Explore Network Channels</h5>

                            {/* Cards Slider */}
                            <div className="category-grid">
                                {categories.map((category, index) => (
                                    <Link to={`/net_channel/${generateSlug(category.name)}`} className="category-link" key={index}>
                                        <div className="category-card">
                                            <img
                                                src={`${category?.thumbnail?.url}`}
                                                alt={`${category.name}`}
                                                className="category-thumbnail"
                                            />

                                        </div>
                                    </Link>
                                ))}
                            </div>
                        </>
                    )}
        </div>

    );
};

export default CategoriesHome;

